<template>
    <section class="col-12" style="padding: 0; margin: 0">
        <label><strong>Members</strong></label>
        <table class="table table-responsive table-striped table-borderless d-table">
            <tbody>
            <tr v-for="(item, itemIndex) in items" :key="'staff' + (item.id ? item.id : item.key)">
                <td style="width: 60%">
                    <select-data-component
                        @selected="(val) => {item.staff_id = val}"
                        :initial-value="item.staff_id || null" :name="`staff-${Math.random()}`"
                        table="users" field-id="id"
                        field-name="CONCAT(name, ' ', last_name)">
                    </select-data-component>
                </td>
                <td style="padding-left: 10px;">
                    <label>&nbsp;&nbsp;&nbsp;<input name="leader" type="radio" v-model="leader" :value="item.staff_id">
                        Is Leader</label>
                </td>
                <td><a @click="deleteLine(item.id, itemIndex)" title="Delete" class="btn btn-danger text-white"><span
                    class="fa fa-trash"></span></a></td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <th colspan="9">
                    <button @click="addLine()" type="button"
                            class="btn btn-success"
                            data-toggle="tooltip"
                            data-original-title="Add more lines">
                        <i class="glyphicon glyphicon-plus-sign"></i>
                        Add Member
                    </button>

                </th>

            </tr>
            </tfoot>
        </table>
    </section>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import TeamMember from "../../../models/TeamMember";
import SelectSearchCustom from "../../generics/CustomSelect.vue";

export default {
    name: "TeamMembersComponent",
    components: {SelectSearchCustom},
    props: {
        members: {
            type: Array,
            required: false
        },
        team_id: {
            required: false
        },

    },
    data: function () {
        return {
            items: [],
            leader: null,
        }
    },
    mounted() {

    },
    methods: {
        addLine() {
            let item = new TeamMember()
            item['key'] = Math.random()
            this.items.push(item);
        },
        setMembers(members) {
            let idStaffLeader = null;
            this.items = members.map((member) => {
                let m = {
                    "id": member.id,
                    "is_leader": member.is_leader,
                    "staff_id": member.staff_id,
                }

                if (parseInt(member.is_leader) === 1) {
                    idStaffLeader = member.staff_id
                }

                return m;
            })

            this.leader = idStaffLeader;
        },
        deleteLine(id, itemIndex) {
            if (id) {
                this.$loading(true);
                let app = this;
                axios.delete(URL_BASE + `/teams/${this.team_id}/member/${id}`)
                    .then((response) => {
                        this.$loading(false);
                        app.items.splice(itemIndex, 1);
                    })
                    .catch(error => {
                        this.$loading(false);
                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {
                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }

                        showMessage('w', message);


                    })
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
    }
}
</script>

<style scoped>

</style>
